import { render, staticRenderFns } from "./addVisitorDetail.vue?vue&type=template&id=534c3f8d&scoped=true&name=addVisitorDetail&"
import script from "./addVisitorDetail.vue?vue&type=script&lang=js&"
export * from "./addVisitorDetail.vue?vue&type=script&lang=js&"
import style0 from "./addVisitorDetail.vue?vue&type=style&index=0&id=534c3f8d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534c3f8d",
  null
  
)

export default component.exports